import { InfoIcon } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import type { MondayBoardColumn, MondaySupportConfig } from '../../types/integrations';
import ColumnSelect from './ColumnSelect';

interface Props {
  form: MondaySupportConfig;
  columns: MondayBoardColumn[];
  isLoadingColumns: boolean;
  disabled?: boolean;
  onChange: (field: keyof MondaySupportConfig, value: unknown) => void;
}

const MondaySupportPrefillSection = ({ form, columns, isLoadingColumns, disabled, onChange }: Props) => (
  <div className="border-t border-border-subtle pt-3">
    <div className="flex items-center gap-1.5 mb-3">
      <span className="text-xs font-semibold uppercase tracking-widest text-text-subtle">Prefill del formulario</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <InfoIcon className="size-3.5 text-text-subtle cursor-default shrink-0" />
          </TooltipTrigger>
          <TooltipContent side="right" className="max-w-72 whitespace-pre-line">
            {
              'La app construye la URL del form así:\n{Form URL}?{Column empresa}={Nombre empresa}&{Column email}={email usuario}&{Column proyecto}={id proyecto}'
            }
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div className="flex flex-col gap-3 sm:max-w-[60%]">
      <ColumnSelect
        label="Columna empresa"
        value={form.companyColumnId}
        columns={columns}
        isLoading={isLoadingColumns}
        disabled={disabled}
        onChange={(v) => onChange('companyColumnId', v)}
      />
      <div className="flex items-center gap-3">
        <Label className="w-36 shrink-0 text-xs font-semibold uppercase tracking-widest text-text-subtle">
          Nombre de Company
        </Label>
        <Input
          type="text"
          value={form.companyName ?? ''}
          onChange={(e) => onChange('companyName', e.target.value)}
          placeholder="Debe ser el mismo que el board de companies"
          className="normal-case font-normal"
          disabled={disabled}
        />
      </div>
      <ColumnSelect
        label="Columna email"
        value={form.emailColumnId}
        columns={columns}
        isLoading={isLoadingColumns}
        disabled={disabled}
        onChange={(v) => onChange('emailColumnId', v)}
      />
      <ColumnSelect
        label="Columna ID proyecto"
        value={form.projectIdColumnId}
        columns={columns}
        isLoading={isLoadingColumns}
        disabled={disabled}
        onChange={(v) => onChange('projectIdColumnId', v)}
      />
    </div>
  </div>
);

export default MondaySupportPrefillSection;
